import {NgModule, LOCALE_ID} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import localeRu from '@angular/common/locales/ru';
import localeKg from '@angular/common/locales/ky';
import localeHy from '@angular/common/locales/hy';
import localeEn from '@angular/common/locales/en';

// Регистрация локалей
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeKg, 'kg');
registerLocaleData(localeHy, 'hy');
registerLocaleData(localeEn, 'en');
import {AppComponent} from './app.component';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {MatTabsModule} from '@angular/material/tabs';
import {SearchComponent} from './search/search.component';
import {RegistrationComponent} from './registration/registration.component';
import {LicenseRegistrationComponent} from './license-registration/license-registration.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatListModule} from '@angular/material/list';
import {routes} from './app.routes';
import {MatRippleModule} from '@angular/material/core';
import {FormlyModule} from '@ngx-formly/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormlyMaterialModule} from '@ngx-formly/material';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {AuthInterceptor} from './auth.interceptor';
import {LogoComponent} from './logo/logo.component';
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatIconModule} from "@angular/material/icon";
import {DinamicLoaderModule} from "./dinamic-loader/dinamic-loader.module";
import {AutocompleteTypeComponent} from "./formly-custom-types/autocomplete-type.component";
import {SettingsTemplateComponent} from "./formly-custom-types/settings-template/settings-template.component";
import {ConnectionTemplateComponent} from "./formly-custom-types/connection-template/connection-template.component";
import {LabelsComponent} from "./formly-custom-types/labels/labels.component";
import {DatepickerTypeComponent} from "./formly-custom-types/datapicker-type.component";
import {FileUploadComponent} from "./formly-custom-types/file-upload/file-upload.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule} from "@angular/material/autocomplete";


@NgModule({
  declarations: [
    AppComponent,
    DatepickerTypeComponent,
    LabelsComponent,
    AutocompleteTypeComponent,
    FileUploadComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule.forRoot(routes, {useHash: true}),
    HttpClientModule,
    MatTabsModule,
    SearchComponent,
    RegistrationComponent,
    LicenseRegistrationComponent,
    MatDatepickerModule,
    MatListModule,
    MatRippleModule,
    FormlyModule.forRoot({
      types: [
        {
          name: 'autocomplete',
          component: AutocompleteTypeComponent,
          // wrappers: ['form-field'],
        },
        {
          name: 'settingsTemplate',
          component: SettingsTemplateComponent,
        },
        {
          name: 'connectionTemplate',
          component: ConnectionTemplateComponent,
        },
        {
          name: 'labels',
          component: LabelsComponent,
        },
        {
          name: 'datepicker',
          component: DatepickerTypeComponent,
          defaultOptions: {
            defaultValue: new Date(),
            templateOptions: {
              datepickerOptions: {},
            },
          },
        },
        {
          name: 'file',
          component: FileUploadComponent,
        },
      ],
    }),
    ReactiveFormsModule,
    FormlyMaterialModule,
    MatButtonModule,
    LogoComponent,
    MatSidenavModule,
    MatIconModule,
    DinamicLoaderModule,
    MatCheckboxModule,
    MatExpansionModule,
    FormsModule,
    MatInputModule,
    MatAutocompleteModule,
  ],
  providers: [HttpClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline'}
    },
    {
      provide: LOCALE_ID,
      useValue: 'en' // Локаль по умолчанию
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
